"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sentry = __importStar(require("@sentry/react"));
const react_1 = require("react");
const client_1 = require("@apollo/client");
const config_1 = __importDefault(require("@mapmaker/config"));
const error_1 = require("@apollo/client/link/error");
const sigv4Fetch_1 = __importDefault(require("./sigv4Fetch"));
const systemTime_1 = require("./systemTime");
const MapmakerApi_1 = __importDefault(require("./MapmakerApi"));
let HAS_LOGGED_SERVER_ERROR = false;
function useMapmakerApolloClient({ businessId, currentCredentials, uri = `${config_1.default.apiGateway.url}/graphql`, isLocal = config_1.default.isLocal, cache = new client_1.InMemoryCache({
    possibleTypes: MapmakerApi_1.default.possibleTypes,
    typePolicies: {
        // File backups have the same file ID (but different backupVersion) so we the cache key to
        // account for that.
        MapmakerFile: {
            keyFields: (file) => {
                if (file.backupVersion && file.backupVersion !== "CURRENT") {
                    return `${file.id}/${file.backupVersion}`;
                }
                else {
                    return file.id;
                }
            },
        },
    },
}), }) {
    return (0, react_1.useMemo)(() => {
        const httpLink = new client_1.HttpLink({
            uri,
            headers: businessId
                ? {
                    "mm-business-id": businessId,
                }
                : undefined,
            fetch: (0, sigv4Fetch_1.default)(currentCredentials, isLocal ? "cognito-identity-id" : null),
        });
        const errorLink = (0, error_1.onError)((_a) => {
            var { networkError } = _a, rest = __rest(_a, ["networkError"]);
            // Would be great to have better fidelity here, but for now this is prettier than the alternatives.
            if (networkError && !HAS_LOGGED_SERVER_ERROR) {
                // Clearing once should be sufficient.
                (0, systemTime_1.clearSystemTimeOffset)();
                function safeLog(data) {
                    try {
                        console.log(JSON.stringify(data));
                    }
                    catch (e) { }
                }
                safeLog(networkError === null || networkError === void 0 ? void 0 : networkError.message);
                safeLog(networkError === null || networkError === void 0 ? void 0 : networkError.name);
                safeLog(networkError === null || networkError === void 0 ? void 0 : networkError.stack);
                safeLog(rest);
                Sentry.captureMessage("Suppressed network error.");
                networkError.message = "Network error.";
                // This flag limits the extreme amount of these errors that we've been seeing.
                HAS_LOGGED_SERVER_ERROR = true;
            }
        });
        return new client_1.ApolloClient({
            link: (0, client_1.from)([errorLink, httpLink]),
            cache,
            connectToDevTools: true,
        });
    }, [businessId, currentCredentials]);
}
exports.default = useMapmakerApolloClient;
//# sourceMappingURL=data:application/json;base64,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